<ng-container *ngIf="!isAuthenticated">
  <button mat-button (click)="login()">로그인</button>
</ng-container>

<ng-container *ngIf="isAuthenticated">
  <ng-container *ngIf="userObservable | async; let user">
  <button mat-icon-button [matMenuTriggerFor]="menu">
    <img *ngIf="user.avatarUrl; else alterAvatar; let avatarUrl" class="rounded-circle avatar-img" [src]="avatarUrl">
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item disabled>{{ user.name }}</button>
    <mat-divider></mat-divider>
    <app-user-update-profile-button [user]="user">
      <button mat-menu-item>개인정보수정</button>
    </app-user-update-profile-button>
    <a class="txt-deco-none" [routerLink]="['/users', user.$key ]">
      <button mat-menu-item>마이페이지</button>
    </a>
    <button mat-menu-item (click)="logout()">로그아웃</button>
  </mat-menu>
  </ng-container>
</ng-container>

<ng-template #alterAvatar>
  <mat-icon>account_circle</mat-icon>
</ng-template>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/core/auth-state/auth-state.component.html